var deployCheckEasySearch = 400;

setTimeout(function() {
  function setCollectionBanner(modelText){
    const titleEl = document.getElementById("collection-title")
    const subTitleEl = document.getElementById("collection-sub-title");
    const model = modelText.split(',')
    titleEl.textContent = `${model[0]} ${model[1]}`;
    titleEl.appendChild(document.createElement("br"))
    const modelEl = document.createElement("span")
    modelEl.textContent = model[2]
    titleEl.appendChild(modelEl)
    subTitleEl.textContent = "Product for"
  }
  if(this.easysearch["curIndex"] === ",,,"){
      for (const [key, value] of Object.entries(this.easysearch.tree)) {
        for(const value_model of value){
          if(value_model.toLowerCase() === window.location.pathname){
              setCollectionBanner(key)
          }
        }
      }
    }else{
      setCollectionBanner(this.easysearch.curIndex)
    }
}, deployCheckEasySearch);
